import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
  alertTitleClasses,
} from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import pr from "../lib/pr";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import axios from "axios";
import get_token from "../lib/get_token";
import { configState } from "../lib/State";
import add_comma from "../lib/add_comma";
import HomeHelpCash from "./HomeHelpCash";
import get_cid from '../lib/get_cid';

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

function HomeCountCash(props) {
  const history = useHistory();
  const { login, cashClick } = props;
  // const onCountClick = () => {
  //   if(login.mcd!=='') {
  //       history.push("/mypage?tab=2&cate=2");
  //   }
  // };
  const [count, setCount] = useState('0');
  const [cid, setCid] = useState(get_cid());

  const load_data = async () => {
    let postData = {
      token: get_token(),
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(configState.api+"/gympass/home_count_cash", postData);
    setCount(result.data.count);
  };

  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
    }
  }, [login.mcd]);

  return (
    <Box
      sx={{
        width: "50%",
      }}
      
    >
      <ThemeProvider theme={typoTheme}>
        <Box
          sx={{ fontSize: "28px", fontFamily: "BebasNeue", color: "#0092a2" }}
          onClick={cashClick}
        >
          { add_comma(count) }
          {/* 5200 */}
        </Box>
      </ThemeProvider>
      <HomeHelpCash />
    </Box>
  );
}
export default HomeCountCash;